import React from 'react';
import { FileUploadPreview } from './FileUploadPreview';
import { MissingOrInvalidFiles } from './MissingOrInvalidFiles';
import { InboxOutlined } from '@ant-design/icons';
import { Upload, Form, Input, Button, Typography, Card } from '../../../../components';

const { Paragraph, Text } = Typography;
const { Dragger } = Upload;

export const SelectZipFile = ({
    isVerifying,
    validationError,
    resetForm,
    fileList,
    uploadProps,
    handleDelete,
    setStep,
    form,
}) => {
    return (
        <>
            {isVerifying && <p>Verifying...</p>}
            {validationError && <MissingOrInvalidFiles error={validationError} resetForm={resetForm} />}
            {!validationError && !isVerifying && (
                <Form layout="vertical" form={form}>
                    <Form.Item
                        label={
                            <>
                                <Text>Import Name</Text>&nbsp;
                                <Text style={{ color: 'rgba(0, 0, 0, 0.45)' }}>(optional)</Text>
                            </>
                        }
                        name="importName"
                        extra="Automatically created if left blank"
                    >
                        <Input placeholder="Import Name" />
                    </Form.Item>
                    <Card className="upload-card">
                        <Form.Item
                            name="rvtoolsCSVUpload"
                            rules={[{ required: true, message: 'Please upload a zip file' }]}
                        >
                            {fileList.length === 0 ? (
                                <Dragger className="custom-upload" {...uploadProps}>
                                    <div className="ant-upload-drag-icon">
                                        <InboxOutlined className="upload-icon" />
                                    </div>
                                    <Text strong>Click or drag file to this area to upload</Text>
                                    <Paragraph className="text-light">
                                        Support for a single Zip or Excel file (50MB max)
                                    </Paragraph>
                                </Dragger>
                            ) : (
                                <FileUploadPreview file={fileList[0]} handleDelete={handleDelete} />
                            )}
                        </Form.Item>
                    </Card>
                    <Form.Item className="button-group" style={{ marginBottom: 0 }}>
                        <div className="button-group">
                            <Button type="default" size="medium" disabled={fileList.length === 0} onClick={resetForm}>
                                Cancel
                            </Button>
                            <Button
                                onClick={() => setStep(1)}
                                type="primary"
                                htmlType="submit"
                                size="medium"
                                disabled={fileList.length === 0}
                            >
                                Continue
                            </Button>
                        </div>
                    </Form.Item>
                </Form>
            )}
        </>
    );
};
